// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2S_4L","right":"styles_right__O43uY"};